import React from 'react';
import Banner from './Banner';
import Header from '../start-page/Header';
import WhySimpleeCreateExists from './WhySimpleeCreateExists';
import WhatWeDo from './WhatWeDo';
import OurPlatformIncludes from './OurPlatformIncludes';
import ProblemSolving from './ProblemSolving';
import CtaSection from '../start-page/CtaSection';
import Footer from '../start-page/Footer';
import styles from './AboutPage.module.css';
const AboutPage: React.FC = () => {
    return (
        <div className={styles.aboutPage}>
            <Header />
            <Banner />
            <WhySimpleeCreateExists />
            <WhatWeDo />
            <ProblemSolving />
            <OurPlatformIncludes />
            <CtaSection />
            <Footer />
        </div>
    );
};

export default AboutPage;
